<template>
  <div>
    <el-card v-loading="isLoading">
      <el-header>
        <span class="cadastro-title">Periodo - Centro de  Custo / Árvore</span>
        <el-button type="primary" icon="el-icon-edit" class="pull-right"  v-show="!showAtualizar" @click="showAtualizar = true"></el-button>
        <a class="pull-right clickable"   @click="showAtualizar = false" v-show="showAtualizar"><i class="icon-close"></i></a>
        <hr/>
      </el-header>
      <el-row v-show="showAtualizar">
        <el-col :span="12">
          <el-transfer
            filterable
            :filter-method="filterMethod"
            :titles="['Lista', 'Selecionados']"
            filter-placeholder="Centros de Custo"
            v-model="form.centroCustoIds"
            :data="centroCustoList"
            :props="{key: 'id',label: 'nome'}">
          </el-transfer>
        </el-col>
        <el-col :span="8">
          <el-select v-model="form.arvoreId" placeholder="Árvore">
            <el-option
              v-for="item in arvoreList"
              :key="item.id"
              :label="item.nome"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="atualizar"> Atualizar</el-button>
        </el-col>
      </el-row>
      <el-row v-show="!showAtualizar">
        <table class="table table-striped table-bordered">
          <thead class="table-dark">
          <tr>
            <th>Periodo</th>
            <th>Árvore</th>
            <th>Centro de Custo</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in list">
            <td>{{ item.periodo_ano}}</td>
            <td>{{ item.arvore_nome}}</td>
            <td>{{ item.centro_custo_nome}}</td>
          </tr>
          </tbody>
        </table>
      </el-row>
    </el-card>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {trataErrors} from "../../domain/utils";
  import {Notification} from "element-ui"

  export default {
    name: "CentroArvore",
    data() {
      return {
        showAtualizar: false,
        list: [],
        isLoading: false,
        form: {
          centroCustoIds: [],
          arvoreId: null
        }
      }
    },
    computed: {
      ...mapState(['centroCustoList', 'arvoreList']),
      periodoId() {
        return this.$route.params.periodo
      }
    },
    methods: {
      async loadList() {
        try {
          this.isLoading = true
          const {data} = await axios.get(`${process.env.API_PATH}/periodo/${this.periodoId}/centrocusto`)
          this.list = [ ...data];
        } catch (error) {
          trataErrors(error)
        } finally {
          this.isLoading = false
        }

      },
      filterMethod(query, item) {
        return item.nome.toLowerCase().indexOf(query.toLowerCase()) > -1;
      },
      async atualizar() {
        try {
          this.form.periodoId = this.periodoId
          this.isLoading = true
          const {data} = await axios.put(`${process.env.API_PATH}/periodo/${this.form.periodoId}/centrocusto`, {...this.form})
          Notification.success("Registros Atualizados com sucesso!")
        } catch (e) {
          trataErrors(e)
        } finally {
          this.isLoading = false
          this.showAtualizar = false
          this.loadList()
        }
      }
    },
    async mounted()
    {
      await this.loadList()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Periodo/CentroArvore.vue